import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authFetch } from './apiFetch';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [auth, setAuth] = useState(null);      // { email, groups }
    const [loading, setLoading] = useState(true); // checando sessão no mount

    // Restaura sessão via cookie existente — chama GET /auth/me
    useEffect(() => {
        authFetch('/auth/me')
            .then(res => res.ok ? res.json() : null)
            .then(data => {
                if (data?.email) {
                    setAuth({ email: data.email, groups: data.groups || [] });
                }
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    // Chamado após login ou respond-challenge bem-sucedidos
    // O backend já setou o cookie; o body retorna apenas { email, groups }
    const login = useCallback((userData) => {
        setAuth({ email: userData.email, groups: userData.groups || [] });
    }, []);

    // Chama POST /auth/logout para o backend expirar o cookie
    const logout = useCallback(async () => {
        try {
            await authFetch('/auth/logout', { method: 'POST' });
        } finally {
            setAuth(null);
        }
    }, []);

    const isAuthenticated = auth !== null;
    const isAdmin = auth?.groups.includes('ADMIN') ?? false;
    const isJudgeAdmin = auth?.groups.includes('JUDGE_ADMIN') ?? false;

    return (
        <AuthContext.Provider value={{ auth, login, logout, isAuthenticated, isAdmin, isJudgeAdmin, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used within AuthProvider');
    return ctx;
}
